import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import GhostLanding from "@/components/GhostLanding";
import NotFoundGhost from "@/components/NotFoundGhost";
import AccessComando from "@/components/AccessComando";
import ComandoLayout from "@/components/ComandoLayout";
import Matriz from "@/pages/Matriz";
import Usuarios from "@/pages/Usuarios";
import Mapa from "@/pages/Mapa";
import Informes from "@/pages/Informes";
import Soporte from "@/pages/Soporte";
import Bitacora from "@/pages/Bitacora";
import Medidor from "@/pages/Medidor";
import SalaMaquinas from "@/pages/SalaMaquinas";
import Auditoria from "@/pages/Auditoria";

const Protected = () => {
  const { authed, expired, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="w-10 h-10 rounded-full border-2 border-[#1F1F24] border-t-[#D4AF37] ax-spin" />
      </div>
    );
  }
  if (authed) return <Outlet />;
  // Sesión expirada (había token válido antes) => llevar al acceso, no al 404 mudo.
  if (expired) return <Navigate to="/acceso-comando" replace />;
  // Sin sesión alguna => la web parece inexistente (404 fantasma) para intrusos.
  return <NotFoundGhost />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<GhostLanding />} />
          <Route path="/acceso-comando" element={<AccessComando />} />
          <Route path="/comando" element={<Protected />}>
            <Route element={<ComandoLayout />}>
              <Route index element={<Navigate to="/comando/matriz" replace />} />
              <Route path="matriz" element={<Matriz />} />
              <Route path="usuarios" element={<Usuarios />} />
              <Route path="mapa" element={<Mapa />} />
              <Route path="informes" element={<Informes />} />
              <Route path="soporte" element={<Soporte />} />
              <Route path="bitacora" element={<Bitacora />} />
              <Route path="medidor" element={<Medidor />} />
              <Route path="sala-de-maquinas" element={<SalaMaquinas />} />
              <Route path="auditoria" element={<Auditoria />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFoundGhost />} />
        </Routes>
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </AuthProvider>
  );
}

export default App;
